// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.current-report_report__z2Q6u {
  width: 100%;
  height: 100%;
  border-radius: 16px; }
  .current-report_report__z2Q6u video {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: contain;
    object-position: center center; }
  .current-report_report__image__8sCxZ {
    width: 100%;
    height: 100%; }
  .current-report_report__description__h3VbX {
    position: absolute;
    top: 0;
    left: 0;
    background: white;
    z-index: 6;
    padding: 10px;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid #fe6100; }
  .current-report_report__fullimage__TVTrY {
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    background-color: #00000070;
    backdrop-filter: blur(5px);
    z-index: 7;
    cursor: pointer; }
    .current-report_report__fullimage_image__Bjhwn {
      margin: 0 auto;
      width: 90%;
      height: 90%;
      object-fit: contain; }

.current-report_slider__tnDc3 {
  width: 100%;
  height: 100%;
  border-radius: 16px; }
  .current-report_slider__image__uH0uo {
    width: 100%;
    height: 100%;
    object-fit: cover; }

.current-report_time__jO7Oo {
  position: absolute;
  left: calc(50% - 100px);
  bottom: 50px;
  color: white;
  display: flex;
  align-items: center;
  gap: 30px;
  border-radius: 31px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 15px; }
  .current-report_time__jO7Oo .current-report_svg__MEoJf {
    opacity: 0.7;
    cursor: pointer;
    transition: all 0.4s; }
    .current-report_time__jO7Oo .current-report_svg__MEoJf:hover {
      opacity: 1; }
  .current-report_time__container__Ayt\\+i {
    display: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-family: Inter;
    line-height: 120%;
    letter-spacing: 0.1px; }
`, "",{"version":3,"sources":["webpack://./src/pages/live/currentReport/current-report.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;EAHvB;IAKQ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B,EAAA;EAElC;IACI,WAAW;IACX,YAAY,EAAA;EAEhB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,yBAAyB,EAAA;EAE7B;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,OAAO;IACP,2BAA2B;IAC3B,0BAA0B;IAC1B,UAAU;IACV,eAAe,EAAA;IACf;MACE,cAAc;MACd,UAAU;MACV,WAAW;MACX,mBAAmB,EAAA;;AAI7B;EACI,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;EACnB;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;;AAIzB;EACI,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,EAAA;EAVrB;IAYM,YAAY;IACZ,eAAe;IACf,oBAAoB,EAAA;IAd1B;MAgBQ,UAAU,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB,EAAA","sourcesContent":[".report{\n    width: 100%;\n    height: 100%;\n    border-radius: 16px;\n    video{\n        width: 100%;\n        height: 100%;\n        border-radius: 16px;\n        object-fit: contain;\n        object-position: center center;\n    }\n    &__image{\n        width: 100%;\n        height: 100%;\n    }\n    &__description{\n        position: absolute;\n        top: 0;\n        left: 0;\n        background: white;\n        z-index: 6;\n        padding: 10px;\n        border-radius: 16px;\n        cursor: pointer;\n        transition: all 0.2s;\n        border: 1px solid #fe6100;;\n    }\n    &__fullimage {\n        width: 100vw;\n        height: 100vh;\n        position: fixed;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        top: 0;\n        left: 0;\n        background-color: #00000070;\n        backdrop-filter: blur(5px);\n        z-index: 7;\n        cursor: pointer;\n        &_image {\n          margin: 0 auto;\n          width: 90%;\n          height: 90%;\n          object-fit: contain;\n        }\n      }\n}\n.slider{\n    width: 100%;\n    height: 100%;\n    border-radius: 16px;\n    &__image{\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n\n.time {\n    position: absolute;\n    left: calc(50% - 100px);\n    bottom: 50px;\n    color: white;\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    border-radius: 31px;\n    background: rgba(0, 0, 0, 0.5);\n    padding: 5px 15px;\n    .svg{\n      opacity: 0.7;\n      cursor: pointer;\n      transition: all 0.4s;\n      &:hover{\n        opacity: 1;\n      }\n    }\n    &__container {\n      display: flex;\n      flex-direction: column;\n      color: #fff;\n      text-align: center;\n      font-size: 14px;\n      font-family: Inter;\n      line-height: 120%;\n      letter-spacing: 0.1px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report": `current-report_report__z2Q6u`,
	"report__image": `current-report_report__image__8sCxZ`,
	"report__description": `current-report_report__description__h3VbX`,
	"report__fullimage": `current-report_report__fullimage__TVTrY`,
	"report__fullimage_image": `current-report_report__fullimage_image__Bjhwn`,
	"slider": `current-report_slider__tnDc3`,
	"slider__image": `current-report_slider__image__uH0uo`,
	"time": `current-report_time__jO7Oo`,
	"svg": `current-report_svg__MEoJf`,
	"time__container": `current-report_time__container__Ayt+i`
};
export default ___CSS_LOADER_EXPORT___;
